import React from 'react';
import { Link } from '@qualifio/ui-commons/dist/components/qlf-prompt';
import { LinkProps } from 'react-router-dom';
import { colorPalette } from '@qualifio/ui-commons';

export function CustomLink(props: LinkProps) {
  return (
    <Link
      style={{ color: colorPalette.secondary.main, textDecoration: 'none !important' }}
      {...props}
    />
  );
}
